import { ActionControllerEventName, ResourcesManager, Tween, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { Box3, BoxGeometry, Color, Mesh, MeshBasicMaterial, Object3D, PlaneGeometry, Quaternion, Vector3 } from 'three';
import { CircleSliderComponent, SlidingMode } from '@verybigthings/vbt-webvr-framework/build/main/ts/components/CircleSliderComponent';
import IconButtonComponent from '@verybigthings/vbt-webvr-framework/build/main/ts/components/IconButtonComponent';
import * as styleConfig from '../../styleConfig';
import { PreparationPickingObjects } from '../../utils/PreparationPickingObjects';
import { PickingControllerEvents } from '@verybigthings/vbt-webvr-framework/build/main/ts/controls/PickingController';
import { FireModule } from './FireModule';
export default class BurnModule extends ViewerModule {
    constructor(instruments, table, pointerController, level, uiContainer) {
        super();
        this.instruments = instruments;
        this.__inited = false;
        this.loopPicked = false;
        this.fireMesh = new Object3D();
        this.pointerController = pointerController;
        this.burner = instruments.burner;
        this.loop = instruments.loop;
        this.dishClean = instruments.dish1;
        this.dish2 = instruments.dish2;
        this.table = table;
        this.uiContainer = uiContainer;
        this.level = level;
        this.loopHolder = new Mesh(new BoxGeometry(.35, 0.1, 1.4), new MeshBasicMaterial({ color: 0x00ff00 }));
        this.loopHolder.position.copy(this.loop.position);
        this.loopHolder.visible = false;
        this.table.getObjectByName('ph_group').add(this.loopHolder);
        this.guide = new Mesh(new PlaneGeometry(4 * 1.25, 4 / 4.52 * 1.25), new MeshBasicMaterial({ color: 0xFFFFFF, map: ResourcesManager.getTexture('petri_guide') }));
        this.guide.position.set(0, -.5, 0);
        this.guide.userData.pcPosition = this.guide.position.clone();
        if (Viewer.controls.zController) {
            this.guide.position.set(0, 5, 0);
            this.guide.scale.setScalar(2);
        }
        this.fireMesh = new Mesh(new PlaneGeometry(.16 * 2.8, .16 * 7.2), new MeshBasicMaterial({
            color: '0xffffff',
            transparent: true,
            visible: false,
        }));
        // this.addObject(this.burnerMoveCircle);
        this.fireMesh.position.set(-.5, 0.02, 0.78);
        this.fireMesh.rotation.set(0, 0, Math.PI / 2);
        this.fireMesh.userData.pcPosition = this.fireMesh.position.clone();
        this.fireMesh.userData.pcRotation = this.fireMesh.rotation.clone();
        this.addObject(this.fireModule = new FireModule());
        this.fireModule.uiObject.position.set(-0.08240480561570343, -1.3297800819191146, 0.3567701521337732);
        // this.fireModule.init();
        window['fire'] = this.fireModule;
    }
    init() {
        // this.addObject(this.fireModule = new FireModule());
        // this.fireModule.uiObject.position.set(-0.08240480561570343, -1.3297800819191146, 0.3567701521337732);
        // // this.fireModule.init();
        // window['fire'] = this.fireModule;
        this.burner = this.instruments.burner;
        this.loop = this.instruments.loop;
        this.dishClean = this.instruments.dish1;
        this.dish2 = this.instruments.dish2;
        this.loopPicked = false;
        this.loopHolder.visible = false;
        let oldLoopPosition = this.loop.position.clone();
        let enableInteraction = true;
        let loopBurned = false;
        // INIT LOOP PICK
        console.log('burn inited');
        const loopBoxSize = new Box3().setFromObject(this.loop).getSize(new Vector3());
        this.loopInnerTaker = new Mesh(new BoxGeometry(loopBoxSize.x / 8, loopBoxSize.y, loopBoxSize.z / 1.6), new MeshBasicMaterial({ visible: false }));
        this.loop.add(this.loopInnerTaker);
        this.actionController.on(ActionControllerEventName.click, this.loop, this.loopActionCallback = (event) => {
            if (!this.level.interaction)
                return;
            if (this.loopPicked || !enableInteraction)
                return;
            this.loopHolder.visible = true;
            setTimeout(() => this.loopPicked = true, 100);
            // this.loopPicked = true;
            this.loop.children[0].position.z = 0.75;
            this.visibilityShadow(this.loop, false);
            if (!Viewer.controls.zController) {
                this.pointerController.setObject(this.loop);
            }
            else {
                const pointerWraper = new Object3D();
                pointerWraper.add(this.loop);
                const matrixWorld = this.loop.matrixWorld.clone();
                PreparationPickingObjects.saveObjectState(pointerWraper);
                PreparationPickingObjects.saveObjectState(this.loop);
                Viewer.scene.add(pointerWraper);
                pointerWraper.position.setFromMatrixPosition(matrixWorld);
                pointerWraper.scale.setFromMatrixScale(matrixWorld);
                this.loop.position.set(0.2, 2.9, 0);
                // this.loop.rotation.set(-1.5, 0.9, 0.7);
                // this.loop.rotation.set(-0.6, 0.95, 0.7);
                this.loop.rotation.set(0.5, 1, -0.4);
                const eventRayDirection = new Vector3(-0.83, 0.28, -0.47);
                // new Vector3(-38.17, -18.52, 12.03)
                console.log('event.ray', event.ray);
                pointerWraper.updateMatrixWorld(true);
                this.loop.scale.setScalar(1.5);
                this.level.lobby.app.zSpacePickingController.forcePickUp(pointerWraper, event.distance, new Vector3(-37.21, -17.4, 9).add(eventRayDirection.clone().multiplyScalar(0.3 * 0.99)), new Quaternion().setFromUnitVectors(new Vector3(0, 0, -1), eventRayDirection), 0);
                // @ts-ignore
                this.level.lobby.app.zSpacePickingController.stylusController.line.visible = false;
                let firstPetriDone = false;
                this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.MOVED, this.loop.parent, () => {
                    this.loopPicked = true;
                    if (!this.level.interaction)
                        return;
                    if (!firstPetriDone && this.loop.getWorldPosition(new Vector3()).distanceTo(this.dish2.getWorldPosition(new Vector3())) < 0.3) {
                        this.fire('bacterias_landed');
                        this.actionController.off(ActionControllerEventName.click, this.dish2);
                        firstPetriDone = true;
                    }
                    else if (firstPetriDone && this.loop.getWorldPosition(new Vector3()).distanceTo(this.dishClean.getWorldPosition(new Vector3())) < 0.3) {
                        this.fire('spread_started');
                        this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.MOVED, this.loop.parent);
                        this.actionController.off(ActionControllerEventName.click, this.dishClean);
                    }
                    const distanceToFire = this.loop.getWorldPosition(new Vector3()).distanceTo(this.fireMesh.getWorldPosition(new Vector3()));
                    if (!firstPetriDone && enableInteraction && distanceToFire < 1) {
                        ResourcesManager.getAudioManger().getAudio('fire_sound').play();
                        enableInteraction = false;
                        this.uiContainer.add(this.burnerMoveCircle.uiObject);
                        this.actionController.off(ActionControllerEventName.click, this.burner, this.callbackBurner);
                    }
                });
                let loopOnTable;
                this.actionController.on(ActionControllerEventName.click, this.table, loopOnTable = (event) => {
                    if (!Viewer.controls.zController)
                        return;
                    if (!this.level.interaction)
                        return;
                    if (!this.loopPicked)
                        return;
                    console.warn(ActionControllerEventName.click, this.table);
                    const distanceToLoopHolder = this.loop.getWorldPosition(new Vector3()).distanceTo(this.loopHolder.getWorldPosition(new Vector3()));
                    if (distanceToLoopHolder < 1.3) {
                        this.loop.children[0].position.z = 0;
                        this.visibilityShadow(this.loop, true);
                        this.level.lobby.app.zSpacePickingController.forceRelease();
                        // @ts-ignore
                        this.level.lobby.app.zSpacePickingController.stylusController.line.visible = true;
                        this.loop.rotation.set(0, 0, 0);
                        this.loop.scale.setScalar(1);
                        this.loop.children[0].scale.setScalar(1);
                        this.pointerController.setObject(null);
                        this.loopHolder.visible = false;
                        setTimeout(() => this.loopPicked = false, 100);
                        // this.loopPicked = false;
                        this.loop.position.copy(oldLoopPosition);
                        this.table.add(this.loop);
                        this.actionController.off(ActionControllerEventName.click, this.table, loopOnTable);
                    }
                });
            }
        });
        if (!Viewer.controls.zController) {
            this.actionController.on(ActionControllerEventName.click, this.loopHolder, (event) => {
                if (Viewer.controls.zController)
                    return;
                if (!this.level.interaction)
                    return;
                if (!this.loopPicked || this.pointerController.currentPointerObjectName === 'loop' || !enableInteraction)
                    return;
                this.loop.children[0].position.z = 0;
                this.visibilityShadow(this.loop, true);
                // if (this.level.lobby.app.zSpacePickingController && Viewer.controls.zController) {
                //     this.level.lobby.app.zSpacePickingController.forceRelease();
                //     this.loop.scale.setScalar(1);
                //     // @ts-ignore
                //     this.level.lobby.app.zSpacePickingController.stylusController.line.visible = true;
                //     setTimeout(() => this.loop.traverse(el => {
                //         if (el.userData.oldRaycast) el.raycast = el.userData.oldRaycast;
                //     }));
                // }
                this.loop.rotation.set(0, 0, 0);
                this.loop.scale.setScalar(1);
                this.loop.children[0].scale.setScalar(1);
                this.pointerController.setObject(null);
                this.loopHolder.visible = false;
                this.loopPicked = false;
                this.loop.position.copy(oldLoopPosition);
                this.table.add(this.loop);
            });
        }
        else {
            this.actionController.on(ActionControllerEventName.click, this.table, (event) => {
                if (!this.level.interaction)
                    return;
                if (!this.loopPicked || !enableInteraction)
                    return;
                console.warn(ActionControllerEventName.click, this.table);
                const distanceToWaterAndColoringLocationsWrapper = this.loop.getWorldPosition(new Vector3()).distanceTo(this.loopHolder.getWorldPosition(new Vector3()));
                if (distanceToWaterAndColoringLocationsWrapper < 1) {
                    this.loop.children[0].position.z = 0;
                    this.visibilityShadow(this.loop, true);
                    this.level.lobby.app.zSpacePickingController.forceRelease();
                    this.loop.scale.setScalar(1);
                    // @ts-ignore
                    this.level.lobby.app.zSpacePickingController.stylusController.line.visible = true;
                    setTimeout(() => this.loop.traverse(el => {
                        if (el.userData.oldRaycast)
                            el.raycast = el.userData.oldRaycast;
                    }));
                    this.loop.rotation.set(0, 0, 0);
                    this.loop.scale.setScalar(1);
                    this.loop.children[0].scale.setScalar(1);
                    this.pointerController.setObject(null);
                    this.loopHolder.visible = false;
                    this.loopPicked = false;
                    this.loop.position.copy(oldLoopPosition);
                    this.table.add(this.loop);
                }
            });
        }
        // BURNER
        this.burnerMoveCircle = new CircleSliderComponent({
            mode: SlidingMode.onlyClockwise,
            diameter: 2.5,
            magnetOnSides: 0.05,
            spaceBetweenObjects: 0.02,
            picker: new IconButtonComponent({
                text: '',
                diameter: 0.6,
                background: styleConfig.SLIDER_PICKER_COLOR.getStyle(),
                textColor: styleConfig.SLIDER_PICKER_TEXT_COLOR.getStyle(),
            }),
            filledPart: {
                width: 0.35,
                mainColor: styleConfig.SLIDER_FILLED_COLOR
            },
            unfilledPart: {
                width: 0.35,
                border: 0.1,
                mainColor: styleConfig.SLIDER_UNFILLED_COLOR,
                borderColor: styleConfig.SLIDER_BORDER_COLOR
            }
        });
        console.log('THIS burner', this);
        console.log('this.burnerMoveCircle:::::: ', this.burnerMoveCircle);
        if (this.fireModule.particleGroups.length === 0)
            this.fireModule.init();
        else
            this.fireModule.uiObject.visible = true;
        this.burnerMoveCircle.uiObject.add(this.fireMesh);
        this.burnerMoveCircle.once('completed', () => {
            this.fire('loop_burned');
            this.fireModule.uiObject.visible = false;
            loopBurned = true;
            this.burnerMoveCircle.dispose();
            enableInteraction = true;
        });
        this.burnerMoveCircle.uiObject.position.set(-.06, -.82, 1.42);
        this.burnerMoveCircle.uiObject.rotateZ(-Math.PI / 2);
        this.burnerMoveCircle.uiObject.userData.pcPosition = this.burnerMoveCircle.uiObject.position.clone();
        this.burnerMoveCircle.uiObject.userData.pcRotation = this.burnerMoveCircle.uiObject.rotation.clone();
        if (Viewer.controls.zController) {
            let framesInFire = 0;
            const framesGoal = 100;
            let material = this.instruments.loop.children[0].material.filter(m => m.name === 'phong64')[0];
            const oldColor = material.color.clone();
            Viewer.on('update', this.loopViewerUpdate = () => {
                if (this.loop.getWorldPosition(new Vector3()).distanceTo(new Vector3(-43, -15.5, 6)) < 0.8) {
                    framesInFire++;
                    material.color.copy(oldColor.clone().lerp(new Color(1, 0.3, 0.3), framesInFire / framesGoal));
                    if (framesInFire >= framesGoal) {
                        this.fire('loop_burned');
                        this.fireModule.uiObject.visible = false;
                        loopBurned = true;
                        this.burnerMoveCircle.uiObject.visible = false;
                        this.burnerMoveCircle.dispose();
                        enableInteraction = true;
                        this.loopViewerUpdate && Viewer.off('update', this.loopViewerUpdate);
                        new Tween(material.color)
                            .to(oldColor, 2000)
                            .easing(TWEEN.Easing.Linear.None)
                            .start();
                    }
                }
            });
        }
        else {
            this.actionController.on(ActionControllerEventName.click, this.burner, this.callbackBurner = () => {
                if (!this.level.interaction)
                    return;
                if (Viewer.controls.zController)
                    return;
                if (this.loopPicked) {
                    ResourcesManager.getAudioManger().getAudio('fire_sound').play();
                    enableInteraction = false;
                    this.uiContainer.add(this.burnerMoveCircle.uiObject);
                    this.actionController.off(ActionControllerEventName.click, this.burner, this.callbackBurner);
                }
            });
        }
    }
    disableBurning() {
        this.actionController.off(ActionControllerEventName.click, this.burner, this.callbackBurner);
        this.loopViewerUpdate && Viewer.off('update', this.loopViewerUpdate);
        this.fireModule.uiObject.visible = false;
    }
    initLanding() {
        let callbackDish2;
        console.log('initLanding');
        this.actionController.on(ActionControllerEventName.click, this.dish2, callbackDish2 = () => {
            if (!this.level.interaction)
                return;
            if (this.loopPicked) {
                this.fire('bacterias_landed');
                this.actionController.off(ActionControllerEventName.click, this.dish2, callbackDish2);
            }
        });
    }
    spreadBacteria() {
        let callbackDishClean;
        this.actionController.on(ActionControllerEventName.click, this.dishClean, callbackDishClean = () => {
            if (!this.level.interaction)
                return;
            if (this.loopPicked) {
                this.fire('spread_started');
                this.actionController.off(ActionControllerEventName.click, this.dishClean, callbackDishClean);
            }
        });
    }
    showPetriGuide() {
        this.guide = new Mesh(new PlaneGeometry(4 * 1.25, 4 / 4.52 * 1.25), new MeshBasicMaterial({ color: 0xFFFFFF, map: ResourcesManager.getTexture('petri_guide') }));
        this.guide.position.set(0, -.5, 0);
        this.guide.userData.pcPosition = this.guide.position.clone();
        if (Viewer.controls.zController) {
            this.guide.position.set(0, 5, 0);
            this.guide.scale.setScalar(2);
        }
        this.uiContainer.add(this.guide);
    }
    hideGuide() {
        if (this.guide && this.guide.parent)
            this.guide.parent.remove(this.guide);
    }
    startSpreading() {
        let callbackDish2;
        this.actionController.on(ActionControllerEventName.click, this.dish2, callbackDish2 = () => {
            if (!this.level.interaction)
                return;
            if (this.loopPicked) {
                this.actionController.off(ActionControllerEventName.click, this.dish2, callbackDish2);
            }
        });
    }
    visibilityShadow(el, visibility = true) {
        const pPlane = el.getObjectByName('pPlane');
        if (pPlane)
            pPlane.visible = visibility;
    }
    update() {
    }
    reset() {
        this.loopPicked = false;
        this.hideGuide();
        if (this.burnerMoveCircle)
            this.burnerMoveCircle.dispose();
        if (this.fireMesh.parent)
            this.fireMesh.parent.remove(this.fireMesh);
        this.fireModule.uiObject.visible = false;
    }
}
